import React, { FC } from "react";

import { DataViewKey } from "@keepeek/commons";
import { BaseComponentProps } from "@keepeek/refront-components";
import { useRecoilValue } from "recoil";

import MediaDetailHeaderNavigation from "../../../components/detail/header/MediaDetailHeaderNavigation";
import { backContextState } from "../../../providers/backContext/atoms";
import { useBackContext } from "../../../providers/backContext/hooks";
import { usePrevNextElement } from "../../../providers/element/hooks";

export type MediaDetailHeaderNavigProps = {} & BaseComponentProps;

const MediaDetailHeaderNavig: FC<React.PropsWithChildren<MediaDetailHeaderNavigProps>> =
  function MediaDetailHeaderNavig() {
    const backContext = useRecoilValue(backContextState);
    const { goBackToSearch } = useBackContext();

    const { previousMediaId, nextMediaId, onPreviousElementClick, onNextElementClick } =
      usePrevNextElement();

    const returnLabel =
      backContext.key === DataViewKey.BASKET_DETAIL
        ? "media-detail.navigation.back.basket.label"
        : "media-detail.navigation.back.label";

    return (
      <MediaDetailHeaderNavigation
        hasNext={!!nextMediaId}
        hasPrevious={!!previousMediaId}
        onPreviousClick={onPreviousElementClick}
        onNextClick={onNextElementClick}
        onBackClick={goBackToSearch}
        returnLabel={returnLabel}
      />
    );
  };

export default MediaDetailHeaderNavig;
